import { render, staticRenderFns } from "./task-tags.vue?vue&type=template&id=c95e6a2c"
import script from "./task-tags.vue?vue&type=script&lang=js"
export * from "./task-tags.vue?vue&type=script&lang=js"
import style0 from "./task-tags.vue?vue&type=style&index=0&id=c95e6a2c&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports